import { Container, SearchDescription } from 'components/search/SourceInstitutionNotFound/components';

import SearchEmptyIcon from 'components/common/SearchEmptyIcon';
import { Spin } from 'antd';
import useTranslation from 'hooks/use-translation';

export default function SourceInsitutionNotFound(): JSX.Element {
  const translation = useTranslation();

  if (!translation) {
    return <Spin />;
  }

  return (
    <Container>
      <SearchEmptyIcon />
      <SearchDescription className='search-institution-not-found-description'>
        {translation.home.isEmpty.prompt}
      </SearchDescription>
    </Container>
  );
}
